import { NewbuildingCarousel, TOnSlideChangeParams } from '@cian/frontend-newbuilding-carousel-component';
import { UIHeading2, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';
import { VerticalArrow } from '../../../../../VerticalSlider/VerticalArrow';
import { firstPaintOptions, mediaSettings } from '../../carouselSettings';

interface IABContentProps {
  title: string;
  description?: string | null;
  images: { url: string }[];
  moreFlatsButton: React.ReactElement | null;
}

export const ABContent: React.FC<React.PropsWithChildren<IABContentProps>> = ({
  title,
  description,
  images,
  moreFlatsButton,
}) => {
  const [firstRender, setFirstRender] = React.useState(true);
  const [currentIndex, setCurrentIndex] = React.useState(1);

  React.useEffect(() => {
    setFirstRender(false);
  }, []);

  const prevSlide = React.useCallback(() => setCurrentIndex(currentIndex - 1), [currentIndex]);
  const nextSlide = React.useCallback(() => setCurrentIndex(currentIndex + 1), [currentIndex]);
  const onSlideChange = React.useCallback(
    ({ currentSlide }: TOnSlideChangeParams) => setCurrentIndex(currentSlide),
    [],
  );

  const count = images.length;
  const counter = `${currentIndex}/${count}`;
  const slides = React.useMemo(
    () =>
      images.map(img => <div key={img.url} className={styles['img']} style={{ backgroundImage: `url(${img.url})` }} />),
    [images],
  );

  return (
    <div className={styles['container']}>
      <div className={styles['gallery']}>
        {!firstRender && (
          <NewbuildingCarousel
            media={mediaSettings}
            firstPaintOptions={firstPaintOptions}
            slides={slides}
            defaultCurrentSlide={currentIndex}
            onSlideChange={onSlideChange}
          />
        )}
        {currentIndex > 1 && <VerticalArrow direction={-1} offset={40} onClick={prevSlide} />}
        {currentIndex < count && <VerticalArrow direction={1} offset={40} onClick={nextSlide} />}
        {count > 1 && (
          <div className={styles['counter']}>
            <UIText1 color="text-primary-default">{counter}</UIText1>
          </div>
        )}
      </div>
      <div className={styles['description']}>
        <div className={styles['title']}>
          <UIHeading2>{title}</UIHeading2>
        </div>
        <UIText1 whiteSpace="pre-wrap">{description}</UIText1>

        {moreFlatsButton && <div className={styles['more-button']}>{moreFlatsButton}</div>}
      </div>
    </div>
  );
};
